export const getAllNodesAndEdgesSvc = async (cy: any) => {
  const fetchArray: any[] = [];
  cy.nodes().positions((node: any) => {
    fetchArray.push({
      group: node._private.group,
      data: node._private.data,
      position: node._private.position,
    });
  });
  cy.edges().positions((edge: any) => {
    fetchArray.push({
      group: edge._private.group,
      data: edge._private.data,
    });
  });
  return fetchArray;
};